<template>
  <div class="row">
    <h1>{{$store.client_id}}</h1>
    <div class="login-form col-md-8 center-block" style="float:none;">
        <form @submit.prevent="submit">
          <div class="form-group">
            <input placeholder="Client ID" class="form-control btn-full-width" type="text" v-model="credentials.clientId" required>
          </div>
          <div class="form-group">
            <input placeholder="Email" class="form-control btn-full-width" type="email" v-model="credentials.email" required autofocus>
          </div>
          <div class="form-group">
            <input placeholder="Password" class="form-control btn-full-width" type="password" v-model="credentials.password" required>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary">Log in</button>
          </div>
          <div v-show="errors" class="errors">
            &#9888;
            {{errors}}
          </div>
        </form>
    </div>
  </div>
</template>

<script>
// login form component

import auth from '../services/auth'
import events from '../services/events'
import { mapGetters } from 'vuex'
import { store, refreshGlobalState } from '@/store'

// parse the querystring from the current URL
// and retrieve a specific parameter
const getQueryStringParameter = function (parameter) {
  const qd = {}
  if (location.search) {
    location.search.substr(1).split('&').forEach((item) => {
      let s = item.split('=')
      let k = s[0]
      let v = s[1] && decodeURIComponent(s[1]); // null-coalescing / short-circuit
      // (k in qd) ? qd[k].push(v) : qd[k] = [v]
      (qd[k] = qd[k] || []).push(v) // null-coalescing / short-circuit
    })
  }
  return qd[parameter]
}

export default {
  data () {
    return {
      credentials: {
        clientId: '',
        email: '',
        password: ''
      },
      errors: ''
    }
  },
  mounted () {
    // provide an initial value for the client ID field
    // can be based on the url: ?clientid=veriflix
    // or a previously stored localstorage value
    if (!this.credentials.clientId) {
      var clientId = localStorage.getItem('client_id') || ''
      if (clientId === 'digiteka') {
        clientId = ''
        localStorage.setItem('client_id', '')
      }
      this.credentials.clientId = getQueryStringParameter('clientid') || clientId
    }
  },
  computed: {
    ...mapGetters(['isLmrConsumer']),
  },
  methods: {
    submit () {
      this.errors = ''
      auth.login(this.credentials).then((success) => {
        refreshGlobalState(store).then(() => {
          if (this.isLmrConsumer) this.$router.push('/videos')
          else this.$router.push('/marker')
        })
      }).catch((error) => {
        if (error.response && error.response.status === 400) {
          this.errors = 'Unable to log in with the provided credentials.'
        } else {
          events.emit('error', error, '', {modal: false})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?5f572abe